import { useTranslation } from 'react-i18next';
import type { LucideIcon } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

/**
 * Every route renders one of these. It names the screen and says what will live there, because an
 * honest empty state is information and a mocked-up table is a lie with a deadline.
 */
export function EmptyState({ id, icon: Icon }: { id: string; icon: LucideIcon }) {
  const { t } = useTranslation();

  return (
    <Card className="mx-auto max-w-2xl">
      <CardContent className="flex flex-col items-center gap-4 p-12 text-center">
        <span className="grid size-12 place-items-center rounded-full bg-accent-wash">
          <Icon className="size-6 text-accent-base" aria-hidden="true" />
        </span>
        <h1 className="text-2xl font-semibold text-ink">{t(`pages.${id}.title`)}</h1>
        <p className="text-base text-ink-secondary">{t(`pages.${id}.blurb`)}</p>
        <span className="rounded-full bg-sunken px-3 py-1 text-sm font-medium text-ink-muted">
          {t('empty.notBuilt')}
        </span>
        <p className="text-sm text-ink-muted">{t('empty.explain')}</p>
      </CardContent>
    </Card>
  );
}
